import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { tasksReducer } from '../../entities/tasks';
import { rootApi } from './baseQuery';

const combinedReducer = combineReducers({
  tasks: tasksReducer,
  [rootApi.reducerPath]: rootApi.reducer,
});

export const rootStore = configureStore({
  reducer: combinedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(rootApi.middleware),
});

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
